import { tools } from '..';
import { goTo } from '../project';

export const selectBikeAuto = props => {
  console.log('Add New Auto Bike', props);

  const pathSelected = 'sc.B3C.currData.mainList';
  const newSelecteds = props.pass.args[0][0].item;

  tools.setData({ path: pathSelected, value: [newSelecteds] });

  goTo('b3bikecheckoutAuto');
};
